import { render, staticRenderFns } from "./Wave.vue?vue&type=template&id=491cb80e&scoped=true"
import script from "./Wave.vue?vue&type=script&lang=js"
export * from "./Wave.vue?vue&type=script&lang=js"
import style0 from "./Wave.vue?vue&type=style&index=0&id=491cb80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491cb80e",
  null
  
)

export default component.exports